export default {
  CR: 'Crimée',
  CU: 'Cuba',
  IR: 'Iran',
  KP: 'Corée du Nord',
  SD: 'Soudan',
  SY: 'Syrie',
}
